<template>
  <box-label-border :label="$t('components.debris_gatherer_report.label')">
    <div class="w-full h-full overflow-y-auto">
      <!-- Header -->
      <section class="text-left mb-4">
        <span
          class="block font-bold uppercase"
          v-text="$t('components.debris_gatherer_report.title')"
        ></span>
        <p
          class="mt-4"
          v-html="
            $t('components.debris_gatherer_report.text', {
              fleet_planet: $t('components.debris_gatherer_report.planet', {
                coordinates:
                  report.debrisGatherers.planetCoordinates || '0/0 : 0/0 : 0',
                name:
                  report.debrisGatherers.planetName ||
                  $t('components.planet.unknown')
              }),
              entity_planet: $t('components.debris_gatherer_report.planet', {
                coordinates: report.entity.planetCoordinates || '0/0 : 0/0 : 0',
                name:
                  report.entity.planetName || $t('components.planet.unknown')
              }),
              timestamp: formatTime(report.date)
            })
          "
        ></p>
        <span
          class="block font-bold uppercase mt-4"
          v-text="$t('components.debris_gatherer_report.resources')"
        ></span>
        <table>
          <tr :key="typeId" v-for="typeId in resourceTypeIds">
            <td style="min-width: 10rem">{{ resourceTypes[typeId].name }}</td>
            <td>
              {{
                formatNumber(
                  (report.entity.debris.find(d => d.typeId === typeId) || {})
                    .amount || 0
                )
              }}
            </td>
          </tr>
        </table>

        <span
          class="block font-bold uppercase mt-4"
          v-text="resourceTypes[capacityType].name"
        ></span>
        <table>
          <tr>
            <td style="min-width: 10rem">
              {{ $t("components.debris_gatherer_report.total_capacity") }}
            </td>
            <td>
              {{ formatNumber(report.totalCapacity) }}
            </td>
          </tr>
          <tr>
            <td style="min-width: 10rem">
              {{ $t("components.debris_gatherer_report.remaining_capacity") }}
            </td>
            <td>
              {{ formatNumber(report.remainingCapacity) }}
            </td>
          </tr>
        </table>
      </section>
    </div>
  </box-label-border>
</template>

<script>
import BoxLabelBorder from "@/components/boxes/BoxLabelBorder";
import DebrisGathererReport from "@/store/model/debris-gatherer-report";
import { StringHelper } from "@/helpers/string-helper";
import { DateHelper } from "@/helpers/date-helper";
import { ResourceTypeId } from "@/helpers/resource-type-id";
import { mapGetters } from "vuex";
export default {
  name: "DebrisGathererReport",
  components: { BoxLabelBorder },
  props: {
    report: {
      type: DebrisGathererReport,
      required: true
    }
  },
  data: () => {
    return {
      resourceTypeIds: [
        ResourceTypeId.METAL,
        ResourceTypeId.CRYSTAL,
        ResourceTypeId.PLASTIC,
        ResourceTypeId.FUEL,
        ResourceTypeId.FOOD,
        ResourceTypeId.PEOPLE
      ],
      capacityType: ResourceTypeId.CAPACITY
    };
  },
  computed: {
    ...mapGetters("data", ["resourceTypes"])
  },
  methods: {
    formatNumber(value) {
      return value >= 0 ? StringHelper.formatNumber(value) : "-";
    },
    formatDate(date) {
      return DateHelper.formatDate(date);
    },
    formatTime(date) {
      return DateHelper.formatTime(date);
    }
  }
};
</script>

<style scoped></style>
